export const SNAPSHOT_CHECK_INTERVAL = 5000;

export const API_NOT_WORKING =
  "Something is wrong with the service. Please try again later.";

export const API_ERRORS = [
  "Chain not supported",
  "not found on chain",
  "to block must be greater than",
];
